<template>
  <div class="back">
    <div class="header">
      <el-col :span="8" class="header-left">
        {{ companyName }}
      </el-col>
      <el-col :span="8"
              class="header-center">易维迅轨道交通集成管理平台设备运维服务平台软件V1.0</el-col>
      
      <el-col :span="8" class="header-right">
        <span>{{ curentTime }}</span><br /><br />
        <!-- <div class="header-op">
          <el-link type="primary" :underline="false" title="返回" @click="goback"><i
              class="el-icon-arrow-left"></i>返回</el-link>
        </div> -->
      </el-col>
    </div>
    <div class="router">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dashboardmain',
  data () {
    return {
      curentTime: '',
      companyName: this.$store.getUser().companyName
    }
  },

  methods: {

    init () {

    },


    goback () {
      history.back(-1)
    },

    getCurentTime () {
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var day = now.getDate();
      var hh = now.getHours();
      var mm = now.getMinutes();
      // var ss = now.getSeconds();
      var clock = year + "-";
      if (month < 10)
        clock += "0";
      clock += month + "-";
      if (day < 10) clock += "0";
      clock += day + " ";
      if (hh < 10) clock += "0";
      clock += hh + ":";
      if (mm < 10) clock += '0';
      clock += mm;
      // clock += mm + ":";
      // if (ss < 10) clock += '0';
      // clock += ss;

      return (clock);
    }
  },
  mounted () {

    setInterval(() => {
      this.curentTime = this.getCurentTime()
    }, 1000)

    this.init()
  },
}
</script>

<style scoped>
.back {
  background: url(../../assets/imgs/dashboard/newimgs/back.png) no-repeat;
  background-size: 100% 100%;
}

.header {
  width: 100%;
  height: 95px;
  background: url(../../assets/imgs/dashboard/newimgs/header.png) no-repeat;
  background-size: 100% 100%;
}

.header-center {
  color: #e9ecec;
  text-align: center;
  padding-top: 12px;
  font-size: 40px;
  font-weight: bold;
  /* font-family: "微软雅黑"; */
  /* font-family: "Adobe 黑体 Std R";
  font-style: "Regular"; */
  letter-spacing: 8px;
}

.header-right {
  color: #e9ecec;
  text-align: right;
  padding-right: 36px;
  padding-top: 15px;
  font-size: 20px;
  /* font-family: "微软雅黑"; */
  font-weight: bold;
  letter-spacing: 2px;
}

.header-left {
  color: #e9ecec;
  padding-left: 36px;
  padding-top: 15px;
  font-size: 20px;
  /* font-family: "微软雅黑"; */
  font-weight: bold;
  letter-spacing: 5px;
}

.header-op {
  margin-right: -32px;
}

.content {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 0px;
  padding-bottom: 0px;
  height: 100vh;
  background-size: 100% 100%;
}

.router {
  height: calc(100vh - 86px);
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
